import axios from 'axios';
import ApiGet from '../sections/mainheader/apiget';

class EntityService {
    constructor(apiUrl) {
        this.GetApiUrl = apiUrl;

        this.GetDynamicUIEntities = () => (axios.get(`${this.GetApiUrl}DynamicUI/GetDynamicUIEntities`));

        this.GetLevelAndDocumentTypeDetailsOfEntity = (selectedValue) => (axios.get(`${this.GetApiUrl}DynamicUI/GetLevelAndDocumentTypeDetailsOfEntity?entityId=${selectedValue}`));

        this.GetDocumentTypeControls = (documentTypeId) => (axios.get(`${this.GetApiUrl}DynamicUI/GetDocumentTypeControls?documentTypeId=${documentTypeId}`));

       
        this.AddDynamicUIData = (payload) => (axios.post(`${this.GetApiUrl}DynamicUI/AddDynamicUIData`, payload));

        this.DeleteDynamicUIData = (rowId) => (axios.post(`${this.GetApiUrl}DynamicUI/DeleteDynamicUIData/${rowId}`));

        

        this.UpdateDynamicUIData = (payload) => (axios.post(`${this.GetApiUrl}DynamicUI/UpdateDynamicUIData`, payload));





        this.GetDetailsOfDynamicUIData = (Id) => (axios.get(`${this.GetApiUrl}DynamicUI/GetDetailsOfDynamicUIData?Id=${Id}`));

        

        this.UploadDocuments = (payload, id) => (axios.post(`${this.GetApiUrl}DynamicUI/UploadDocuments?postedDataId=${id}`, payload));



    }
}

export default ApiGet().then((apiUrl) => new EntityService(apiUrl));
